import { render, staticRenderFns } from "./ReviewCommentsPerQuestion.vue?vue&type=template&id=7b2c8c93&scoped=true"
import script from "./ReviewCommentsPerQuestion.vue?vue&type=script&lang=js"
export * from "./ReviewCommentsPerQuestion.vue?vue&type=script&lang=js"
import style0 from "./ReviewCommentsPerQuestion.vue?vue&type=style&index=0&id=7b2c8c93&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b2c8c93",
  null
  
)

export default component.exports